import hljs from "highlightjs";

window.hljs = hljs;

document.addEventListener("DOMContentLoaded", () => {
    if (document.body.classList.contains("code")) {
        hljs.initHighlighting();
    }

    document.querySelectorAll('.copy-code').forEach(el => {
        el.addEventListener('click', e => {
            const container = el.parentElement;
            const code = container.querySelector('pre').textContent;
            
            navigator.clipboard.writeText(code);
            el.querySelector('span:not(.glyphicon)').textContent = 'Copied!';

            setTimeout(() => {
                el.querySelector('span:not(.glyphicon)').textContent = 'Copy';
            }, 1500);
        });
    });
});
